import React from 'react'
import { AccountCode, Caret, DateCell } from './interactive.styled'

type Props = {
  /** Matches the leading columns on data rows before the line-item label. */
  variant?: 'account' | 'date' | 'caret'
}

export const ReportLeadingGutter: React.FC<Props> = ({ variant = 'account' }) => (
  <>
    <Caret aria-hidden />
    {variant === 'date' ? <DateCell $header aria-hidden /> : null}
    {variant === 'account' ? <AccountCode aria-hidden /> : null}
  </>
)
